import { render, staticRenderFns } from "./guest-registration-footer.vue?vue&type=template&id=077e6cba&"
import script from "./guest-registration-footer.vue?vue&type=script&lang=ts&"
export * from "./guest-registration-footer.vue?vue&type=script&lang=ts&"
import style0 from "./guest-registration-footer.vue?vue&type=style&index=0&id=077e6cba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports